import React from "react";
import { Link } from "react-router-dom";
import SiteShell from "../../components/layout/SiteShell";
import ContentPageLayout from "../../components/content/ContentPageLayout";
import SEO from "../../components/seo/SEO";
import WellnessDisclaimer from "../../components/content/WellnessDisclaimer";
import { BLENDS } from "../../lib/blends";

export default function BlendsIndexPage() {
  return (
    <SiteShell>
      <SEO
        title="Curated blend routines | MossMatrix"
        description="Routine-based sea moss gel blend ideas from MossMatrix: gold and purple bases with herbs, roots, and botanical powders. Flavour-led inspiration, not medical formulas."
        path="/blends"
        ogType="website"
      />
      <ContentPageLayout
        eyebrow="Blends"
        title="Blend routines, not prescriptions."
        subtitle="These are tasting notes and pantry inspiration. Names describe mood and herbal character, not cures. Pick a routine for ideas, then start with plain Gold or Purple."
      >
        <div className="grid md:grid-cols-2 gap-6 mb-14">
          {BLENDS.map((b) => (
            <Link
              key={b.slug}
              to={`/blends/${b.slug}`}
              className="group rounded-3xl border border-cream bg-white p-6 shadow-soft hover:shadow-hover transition"
            >
              <span className="text-[10px] tracking-[0.2em] uppercase text-gold">Routine</span>
              <h2 className="font-serif text-2xl text-forest mt-2 group-hover:text-botanical transition">{b.name}</h2>
              <p className="mt-2 text-sm text-botanical/80 leading-relaxed">{b.headline}</p>
              <p className="mt-4 text-xs tracking-widest uppercase text-forest/60 group-hover:text-forest">View routine →</p>
            </Link>
          ))}
        </div>

        <WellnessDisclaimer className="max-w-2xl mx-auto mb-8" />
        <div className="text-center">
          <Link to="/mix-ins" className="inline-flex rounded-full bg-forest text-cream px-8 py-3 text-sm font-medium hover:bg-botanical transition">
            Explore mix-in ideas
          </Link>
          <p className="mt-4 text-sm text-botanical/70">
            <Link to="/ingredients" className="underline hover:text-forest">
              Explore the ingredient library
            </Link>
            {" · "}
            <Link to="/shop" className="underline hover:text-forest">
              Shop
            </Link>
            {" · "}
            <Link to="/faq" className="underline hover:text-forest">
              FAQ
            </Link>
          </p>
        </div>
      </ContentPageLayout>
    </SiteShell>
  );
}
